import React, { Component, useEffect } from 'react'
import "./Navbar.css"
import logo from "../../images/streelogo.png"
import { c1, c2, c3, c4, green, pink, white } from "../../constants"
import { FaCartArrowDown, FaFacebook, FaInstagram, FaLinkedin, FaSearch, FaTwitter, FaYoutube } from "react-icons/fa";
import { Link } from 'react-scroll'
import SwipeableTemporaryDrawer from '../Drawer/Drawer';
import { useNavigate } from 'react-router-dom';

export default function Navbar() {

    const handleclick = () => {
        const link = "https://drive.google.com/file/d/1Xp-PJsVtK7eiU8Y6HhiMek20viEvHw0P/view?usp=sharing";
        window.open(link, '_blank', 'noreferrer');
    }
    let navigate = useNavigate();
    const push_back = () => {
        navigate('/home', { replace: "true" });
    }

    return (

        <div style={{ display: "flex", justifyContent: "center", zIndex: 5 }}>

            <div className='nav_container'>
                <div className='navbar' style={{ alignItems: "center" }}>

                    {/* logo section */}
                    <Link to='' onClick={push_back}><div className='navlogo'>
                        <img src={logo} alt='logo' height="70px"></img>
                    </div></Link>




                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "60px" }}>

                        {/* links */}
                        <ul style={{ fontSize: "15px", listStyle: "none", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", textDecoration: "none", gap: "40px", marginTop: "10px" }}>

                            <li className='navbar_item' ><Link to="home" replace="true" spy={true} smooth={true} offset={-100} duration={100} >Home</Link></li>
                            <li className='navbar_item' ><Link to="about" spy={true} smooth={true} offset={-150} duration={100} >About Us </Link></li>
                            <li className='navbar_item' ><Link to="focus" spy={true} smooth={true} offset={-150} duration={100} >Our Focus </Link></li>
                            <li className='navbar_item' ><Link to="teams" spy={true} smooth={true} offset={-150} duration={100} >Teams</Link></li>
                            <li className='navbar_item' ><Link to="salaamstree" spy={true} smooth={true} offset={-100} duration={100} >Salaam Stree</Link></li>
                            <li className='navbar_item' ><Link to="contact" spy={true} smooth={true} offset={-150} duration={100} >Contact</Link></li>

                        </ul>

                        {/* social icons */}
                        <ul style={{ listStyle: "none", display: "flex", flexDirection: "row", justifyContent: "space-between", textDecoration: "none", gap: "20px", alignItems: "center", marginTop: "10px" }}>

                            <a href='https://twitter.com/StreeSafety' target="_blank" style={{ textDecoration: "none" }}> <FaTwitter style={{ fontSize: "20px", color: pink }}></FaTwitter> </a>
                            <a href='https://www.facebook.com/people/STREE-Safety/100089926762389/' target="_blank" style={{ textDecoration: "none" }}> <FaFacebook style={{ fontSize: "20px", color: pink }}></FaFacebook> </a>
                            <a href='https://www.instagram.com/streesafety/' target="_blank" style={{ textDecoration: "none" }}> <FaInstagram style={{ fontSize: "20px", color: pink }}></FaInstagram> </a>
                            <a href='https://www.youtube.com/channel/UCVUvxFTWAsZM9h0PXpdQlOQ' target="_blank" style={{ textDecoration: "none" }}> <FaYoutube style={{ fontSize: "20px", color: pink }}></FaYoutube> </a>
                            <a href='https://www.linkedin.com/company/streesafety/' target="_blank" style={{ textDecoration: "none" }}> <FaLinkedin style={{ fontSize: "20px", color: pink }}></FaLinkedin> </a>

                        </ul>

                    </div>


                    {/* actions */}
                    <div style={{ display: "flex", justifyContent: "center", }}>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>

                            <button style={{ padding: "10px", backgroundColor: "white", border: "1.5px solid", borderColor: green, borderRadius: "5px", color: green, marginLeft: "20px", fontWeight: "600" }} onClick={handleclick}>Empower Bharat</button>

                        </div>
                    </div>





                </div>

            </div>

            <div className='navbar-native'>

                <img src={logo} alt='logo' height="60px" style={{ margin: "5px", marginLeft: "20px", padding: "5px" }}></img>


                {/* sidebar */}
                <div>
                    <SwipeableTemporaryDrawer></SwipeableTemporaryDrawer>
                </div>





            </div>
        </div>

    )
}


export function Navbarsalaamstree() {

    const handleclick = () => {
        const link = "https://drive.google.com/file/d/1Xp-PJsVtK7eiU8Y6HhiMek20viEvHw0P/view?usp=sharing";
        window.open(link, '_blank', 'noreferrer');
    }
    let navigate = useNavigate();
    const push_back = () => {

        navigate('/home', { replace: true });
    }

    return (

        <div style={{ display: "flex", justifyContent: "center", zIndex: 5 }}>

            <div className='nav_container'>
                <div className='navbar' style={{ alignItems: "center" }}>

                    {/* logo section */}
                    <Link to='' onClick={push_back}><div className='navlogo'>
                        <img src={logo} alt='logo' height="70px"></img>
                    </div></Link>




                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "60px" }}>

                        {/* links */}
                        <ul style={{ fontSize: "15px", listStyle: "none", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", textDecoration: "none", gap: "40px", marginTop: "10px" }}>

                            <li className='navbar_item' ><Link to='' onClick={push_back} replace="true" spy={true} smooth={true} offset={-100} duration={100} >Home</Link></li>
                            <li className='navbar_item' ><Link to='' onClick={push_back} spy={true} smooth={true} offset={-150} duration={100} >About Us </Link></li>
                            <li className='navbar_item' ><Link to='' onClick={push_back} spy={true} smooth={true} offset={-150} duration={100} >Our Focus </Link></li>
                            <li className='navbar_item' ><Link to='' onClick={push_back} spy={true} smooth={true} offset={-150} duration={100} >Teams</Link></li>
                            <li className='navbar_item' ><Link to='' onClick={push_back} spy={true} smooth={true} offset={-100} duration={100} >Salaam Stree</Link></li>
                            <li className='navbar_item' ><Link to='' onClick={push_back} spy={true} smooth={true} offset={-150} duration={100} >Contact</Link></li>

                        </ul>

                        {/* social icons */}
                        {/* social icons */}
                        <ul style={{ listStyle: "none", display: "flex", flexDirection: "row", justifyContent: "space-between", textDecoration: "none", gap: "20px", alignItems: "center", marginTop: "10px" }}>

                            <a href='https://twitter.com/StreeSafety' target="_blank" style={{ textDecoration: "none" }}> <FaTwitter style={{ fontSize: "20px", color: pink }}></FaTwitter> </a>
                            <a href='https://www.facebook.com/people/STREE-Safety/100089926762389/' target="_blank" style={{ textDecoration: "none" }}> <FaFacebook style={{ fontSize: "20px", color: pink }}></FaFacebook> </a>
                            <a href='https://www.instagram.com/streesafety/' target="_blank" style={{ textDecoration: "none" }}> <FaInstagram style={{ fontSize: "20px", color: pink }}></FaInstagram> </a>
                            <a href='https://www.youtube.com/channel/UCVUvxFTWAsZM9h0PXpdQlOQ' target="_blank" style={{ textDecoration: "none" }}> <FaYoutube style={{ fontSize: "20px", color: pink }}></FaYoutube> </a>
                            <a href='https://www.linkedin.com/company/streesafety/' target="_blank" style={{ textDecoration: "none" }}> <FaLinkedin style={{ fontSize: "20px", color: pink }}></FaLinkedin> </a>

                        </ul>

                    </div>


                    {/* actions */}
                    <div style={{ display: "flex", justifyContent: "center", }}>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>

                            <button style={{ padding: "10px", backgroundColor: "white", border: "1.5px solid", borderColor: green, borderRadius: "5px", color: green, marginLeft: "20px", fontWeight: "600" }} onClick={handleclick}>Empower Bharat</button>

                        </div>
                    </div>





                </div>

            </div>

            <div className='navbar-native'>

                <img src={logo} alt='logo' height="60px" style={{ margin: "5px", marginLeft: "20px", padding: "5px" }}></img>


                {/* sidebar */}
                <div>
                    <SwipeableTemporaryDrawer></SwipeableTemporaryDrawer>
                </div>





            </div>
        </div>

    )
}

